import { useEffect, useMemo, useState } from "react"

export const useUserAgentInfo = () => {
  const [userAgent, setUserAgent] = useState("")

  useEffect(() => {
    if (typeof navigator === "undefined") return
    setUserAgent(navigator.userAgent || "")
  }, [])

  return useMemo(() => {
    const isIOS = /iPhone|iPad|iPod/i.test(userAgent)
    const isSafari = /Safari/i.test(userAgent)
    const isSafariOnly =
      /^(?:(?!chrome|android|crios|fxios|opios).)*safari/i.test(userAgent)
    const isChromeOniOS = isIOS && /Chrome|CriOS|FxiOS|OPiOS/i.test(userAgent)

    return {
      userAgent,
      isIOS,
      isSafari,
      isSafariOnly,
      isIOSAndSafari: isIOS && isSafari,
      isChromeOniOS,
    }
  }, [userAgent])
}
